import { cloneElement } from 'react';
import { ShippingTypeIcons } from './common';

/** The shipping type's icon with the given props; nothing for a type it has none for. */
export function shippingTypeIcon(type: string, props: Record<string, unknown>) {
  const icon = ShippingTypeIcons[type];
  return icon ? cloneElement(icon, props) : null;
}
